import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=7f0b33f0&scoped=true"
import script from "./SidebarNav.vue?vue&type=script&lang=js"
export * from "./SidebarNav.vue?vue&type=script&lang=js"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=7f0b33f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0b33f0",
  null
  
)

export default component.exports